/**
 * Role-Based Route
 */

import { Navigate } from 'react-router-dom';
import { ROUTES } from './routeConfig';

const RoleBasedRoute = ({ children, allowedRoles }) => {
  // Check localStorage directly
  const storedUser = localStorage.getItem('user');
  
  if (!storedUser) {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />;
  }
  
  try {
    const user = JSON.parse(storedUser);
    
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to={ROUTES.ERRORS.UNAUTHORIZED} replace />;
    }
    
    return children;
  } catch {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />;
  }
};

export default RoleBasedRoute;

